import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faFileDownload, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import './Tier3.css';

class Tier3 extends PureComponent {

	whatIcon(type) {
		let icon = null;
		switch (type) {
			case "link":
				icon = faExternalLinkAlt;
				break;
			case "download":
				icon = faFileDownload;
				break;
			case "email":
				icon = faEnvelope;
				break;
			default:
				icon = faExternalLinkAlt;
		}
		return icon;
	}

	renderOptions(data) {
		return data.map((item) => {
			const external = !item.url.includes('wisdomtree.com') && !item.url.includes('mailto') ? true : false;
			return (
				<div className='col-md-5'>
					<div
						className='tier3Box'
					>
						<div className='col-md-10'>
							{external &&
								<a href="#externalLinkModal" className="option-link" data-toggle="modal" data-ref={item.url}>{item.name}</a>
							}
							{!external &&
								<a href={item.url} target="_blank" rel="noopener noreferrer" className="option-link">{item.name}</a>
							}
						</div>
						<div className='col-md-2' style={{ marginTop: '10px' }}>
							<FontAwesomeIcon icon={this.whatIcon(item.type)} style={{ fontSize: '28px', color: '#5060F6' }} />
						</div>
					</div>
				</div>
			);
		});
	}

	renderTitles(data) {
		return data.map((item) => {
			return (
				<div>
					<div className="row">
						<div className='col-md-12 option-title'>
							{item.title}
						</div>
					</div>
					<div className="row">
						{this.renderOptions(item.options)}
					</div>
					<div className="row">
						<div className='col-md-12'>
							<div className='option-line'></div>
						</div>
					</div>
				</div>
			);
		});
	}

	renderDisclaimer(disclaimer) {
		return disclaimer.map((item) => {
			return (
				<div>
					<div className="row">
						<div className='col-md-12 option-text'>
							{item.text}
						</div>
					</div>
				</div>
			);
		});
	}

	render() {
		const {
			data,
			disclaimer
		} = this.props;

		return (
			<div>
				<div>
					{this.renderTitles(data)}
				</div>
				{disclaimer[0] &&
					<div>
						{this.renderDisclaimer(disclaimer)}
					</div>
				}
			</div>
		)
	}

}

export default (Tier3);
